import { api } from './api';

export interface MonthPoint { month: string; billedPaise: number; collectedPaise: number; }
export interface AgeingBucket { label: string; invoices: number; outstandingPaise: number; }
export interface ClassCollection {
  academicClassId: string | null; classLabel: string; students: number;
  billedPaise: number; collectedPaise: number; outstandingPaise: number; collectedPct: number;
}
export interface FeeTypeSlice { feeType: string; billedPaise: number; collectedPaise: number; outstandingPaise: number; }
export interface CollectionSummary {
  billedPaise: number; collectedPaise: number; outstandingPaise: number; overduePaise: number;
  collectionRatePct: number; totalInvoices: number; paidInvoices: number; partInvoices: number;
  unpaidInvoices: number; studentsWithDues: number; concessionPaise: number; lateFeePaise: number;
}
export interface FeeAnalytics {
  academicYear: string;
  summary: CollectionSummary;
  months: MonthPoint[];
  ageing: AgeingBucket[];
  classes: ClassCollection[];
  feeTypes: FeeTypeSlice[];
  expectedNext30Paise: number;
}

export const analyticsApi = {
  fees: (year?: string, months = 12) =>
    api.get<FeeAnalytics>(`/api/analytics/fees?months=${months}${year ? `&year=${encodeURIComponent(year)}` : ''}`),
};

// ---------- trust-level rollups ----------
export interface InstitutionRollup {
  institutionId: string; institutionName: string; institutionType: string;
  activeStudents: number; newAdmissionsThisYear: number;
  billedPaise: number; collectedPaise: number; outstandingPaise: number; overduePaise: number;
  collectionRatePct: number; attendanceMarkedDays: number; attendanceRatePct: number;
  studentsWithDues: number;
}
export interface CampusRollup {
  campusId: string; campusName: string; city: string | null; isActive: boolean;
  institutions: number; activeStudents: number; newAdmissionsThisYear: number;
  billedPaise: number; collectedPaise: number; outstandingPaise: number; overduePaise: number;
  collectionRatePct: number; attendanceRatePct: number;
  institutionBreakdown: InstitutionRollup[];
}
export interface TrustTotals {
  campuses: number; institutions: number; activeStudents: number; newAdmissionsThisYear: number;
  billedPaise: number; collectedPaise: number; outstandingPaise: number; overduePaise: number;
  collectionRatePct: number; attendanceRatePct: number; studentsWithDues: number;
}
export interface RollupFlag { campusId: string; campusName: string; severity: string; message: string; }
export interface TrustRollup {
  academicYear: string; totals: TrustTotals; campuses: CampusRollup[];
  flags: RollupFlag[]; caveat: string | null;
}

export const rollupApi = {
  trust: (year?: string) =>
    api.get<TrustRollup>(`/api/analytics/rollup${year ? `?year=${encodeURIComponent(year)}` : ''}`),
};
